import { Component } from "react";
import { Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, Row, Stack } from "react-bootstrap";
import keycloak from "../util/keycloak";
import { AppApiManager } from "../util/appApiManager";
import { AnalyticItem } from "../components/analyticItem";
import { ResponseList } from "../components/responseList";

export class AnalyticsView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            colorblindSetting: false,
            showFreeResponses: false,
        }
        this.apiManager = new AppApiManager()
    }

    async refreshTemplateList() {
        const templates = await this.apiManager.getTemplates()
        this.setState({templates})
    }

    async componentDidMount() {
        if (!this.apiManager.hasValidAuthToken()) {
            keycloak.login()
            return
        }
        await this.refreshTemplateList()
        if (keycloak.tokenParsed?.userDomain === 'District') {
            this.setState({
                schools: ['All schools', ...(await this.apiManager.getSchools())],
                userDomain: keycloak.tokenParsed?.userDomain,
                schoolSelection: 'All schools',
            })
        } else {
            this.setState({
                schoolSelection: keycloak.tokenParsed?.userDomain,
                userDomain: keycloak.tokenParsed?.userDomain,
            })
        }
    }

    toggleFormSelect = async (field, value) => {
        let analyticsData
        if (field === 'colorblindSetting' || field === 'showFreeResponses') {
            this.setState({
                [field]: !this.state[field],
            })
            return
        } else if (field === 'templateSelection') {
            let schoolSelection = undefined
            if (this.state.userDomain === 'District' && this.state.schoolSelection !== 'All schools') {
                schoolSelection = this.state.schoolSelection
            }
            analyticsData = await this.apiManager.getTemplateAnalytics(value._id, schoolSelection)
        } else {
            const schoolSelection = value === 'All schools' ? undefined : value
            if (this.state.templateSelection) {
                analyticsData = await this.apiManager.getTemplateAnalytics(this.state.templateSelection._id, schoolSelection)
            }
        }
        this.setState({
            [field]: value,
            analytics: analyticsData.formAnalytics,
            responseCount: analyticsData.responseCount,
        })
    }

    filteredAnalytics = () => {
        if (this.state.showFreeResponses) {
            return this.state.analytics
        } else {
            return this.state.analytics.filter(item => item.questionType !== 0)
        }
    }

    render() {
        return (
            <Container className="p-4" fluid>
                <h2 className="m-2">Analytics</h2>
                <Row className="m-2">
                    <Col className="mb-2" xs={6} sm={4} md={3} lg={2}>
                        <Dropdown>
                            <DropdownToggle style={{ maxWidth: '100%', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} variant="secondary">{this.state.templateSelection?.templateName || 'Select Form...'}</DropdownToggle>
                            <DropdownMenu>
                                {this.state.templates && this.state.templates.map((template, idx) => 
                                    <DropdownItem key={idx} onClick={() => {this.toggleFormSelect('templateSelection', template)}}>
                                        {template.templateName}
                                    </DropdownItem>
                                )}
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                   <Col className="mb-2" xs={6} sm={4} md={3} lg={2}>
                        <Dropdown>
                            <DropdownToggle style={{ maxWidth: '100%', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} disabled={this.state.userDomain !== 'District'} variant="secondary">{this.state.schoolSelection || 'Select School...'}</DropdownToggle>
                            {this.state.userDomain === 'District' &&
                                <DropdownMenu>
                                    {this.state.schools.map((school, idx) => 
                                        <DropdownItem key={idx} onClick={() => {this.toggleFormSelect('schoolSelection', school)}}>
                                            {school}
                                        </DropdownItem>
                                    )}
                                </DropdownMenu>
                            }
                        </Dropdown>
                   </Col> 
                    
                    {this.state.analytics 
                        && this.state.analytics.some(item => item.questionType == 1 || item.questionType == 2)
                        && <Col className="mb-2" xs={6} sm={4} md={3} lg={2}>
                                <Form.Check
                                    type="switch"
                                    checked={this.state.colorblindSetting}
                                    onChange={() => this.toggleFormSelect('colorblindSetting', undefined)}
                                    label="Color-blind setting"
                                />
                            </Col>
                    }
                    {this.state.analytics
                        && this.state.analytics.some(item => item.questionType == 0)
                        && <Col className="mb-2" xs={6} sm={4} md={3} lg={2}>
                                <Form.Check 
                                    type="switch"
                                    checked={this.state.showFreeResponses}
                                    onChange={() => this.toggleFormSelect('showFreeResponses', undefined)}
                                    label="Show free responses"
                                />
                            </Col>
                    }
                </Row>
                {this.state.responseCount !== undefined && <h4 className="my-4 mx-2">Response count: {this.state.responseCount}</h4>}
                <Row className="m-3">
                    {this.state.analytics && this.filteredAnalytics().map((item, idx) =>
                        <Col key={idx} xs={12} sm={12} md={6} lg={6} xl={4}>
                            <h4 className="text-center text-truncate" title={item.question}>{item.question}</h4>
                            {(item.questionType == 1 || item.questionType == 2) 
                                ? <AnalyticItem colorblindSetting={this.state.colorblindSetting} analytics={item} />
                                : <ResponseList responses={item.freeResponses} />}
                        </Col>
                    )}
                </Row>
            </Container>
        )
    }
    
}